module.exports = __webpack_public_path__ + "img/NoLightAnimationv2.86ed4dd2.gif";